import React, { Fragment } from 'react';

export default {
  timer: {
    viewBox: '0 0 24 24',
    width: 24,
    height: 24,
    body: () => (
      <path d="M14 1H9.99998C9.44998 1 8.99998 1.45 8.99998 2C8.99998 2.55 9.44998 3 9.99998 3H14C14.55 3 15 2.55 15 2C15 1.45 14.55 1 14 1ZM12 14C12.55 14 13 13.55 13 13V9C13 8.45 12.55 8 12 8C11.45 8 11 8.45 11 9V13C11 13.55 11.45 14 12 14ZM19.03 7.39L19.78 6.64C20.16 6.26 20.17 5.63 19.78 5.24L19.77 5.23C19.38 4.84 18.76 4.85 18.37 5.23L17.62 5.98C16.07 4.74 14.12 4 12 4C7.19998 4 3.11998 7.96 2.99998 12.76C2.86998 17.84 6.93998 22 12 22C16.98 22 21 17.97 21 13C21 10.88 20.26 8.93 19.03 7.39ZM12 20C8.12998 20 4.99998 16.87 4.99998 13C4.99998 9.13 8.12998 6 12 6C15.87 6 19 9.13 19 13C19 16.87 15.87 20 12 20Z" />
    ),
  },
  circle_checkmark: {
    viewBox: '0 0 20 20',
    width: 20,
    height: 20,
    body: () => (
      <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM7.29 14.29L3.7 10.7C3.31 10.31 3.31 9.68 3.7 9.29C4.09 8.9 4.72 8.9 5.11 9.29L8 12.17L14.88 5.29C15.27 4.9 15.9 4.9 16.29 5.29C16.68 5.68 16.68 6.31 16.29 6.7L8.7 14.29C8.32 14.68 7.68 14.68 7.29 14.29Z" />
    ),
  },
  checkbox: {
    viewBox: '0 0 24 24',
    width: 24,
    height: 24,
    body: () => (
      <Fragment>
        <rect
          x="3"
          y="3"
          width="18"
          height="18"
          rx="1"
          fill="white"
          strokeWidth="2"
        />
      </Fragment>
    ),
  },
  checkbox_checked: {
    viewBox: '0 0 24 24',
    width: 24,
    height: 24,
    body: () => (
      <Fragment>
        <rect x="3" y="3" width="18" height="18" rx="1" strokeWidth="2" />
        <path
          d="M9.75 15.1275L7.1475 12.525C6.855 12.2325 6.3825 12.2325 6.09 12.525C5.7975 12.8175 5.7975 13.29 6.09 13.5825L9.225 16.7175C9.5175 17.01 9.99 17.01 10.2825 16.7175L18.2175 8.78249C18.51 8.48999 18.51 8.01749 18.2175 7.72499C17.925 7.43249 17.4525 7.43249 17.16 7.72499L9.75 15.1275Z"
          fill="white"
          stroke="white"
        />
      </Fragment>
    ),
  },
  info_outline: {
    viewBox: '0 0 24 24',
    width: 24,
    height: 24,
    body: () => (
      <path d="M11 7H13V9H11V7ZM12 17C12.55 17 13 16.55 13 16V12C13 11.45 12.55 11 12 11C11.45 11 11 11.45 11 12V16C11 16.55 11.45 17 12 17ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" />
    ),
  },
  info_filled: {
    viewBox: '0 0 24 24',
    width: 24,
    height: 24,
    body: () => (
      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 17C11.45 17 11 16.55 11 16V12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12V16C13 16.55 12.55 17 12 17ZM13 9H11V7H13V9Z" />
    ),
  },
  clear_complete: {
    viewBox: '0 0 24 24',
    width: 24,
    height: 24,
    body: () => (
      <Fragment>
        <path
          d="M9.00001 16.17L5.53001 12.7C5.14002 12.31 4.51001 12.31 4.12001 12.7C3.73001 13.09 3.73001 13.72 4.12001 14.11L8.30001 18.29C8.69001 18.68 9.32001 18.68 9.71001 18.29L20.29 7.71001C20.68 7.32001 20.68 6.69001 20.29 6.30001C19.9 5.91001 19.27 5.91001 18.88 6.30001L9.00001 16.17Z"
          fill="#323232"
        />
        <path
          d="M11.8891 5.11471C11.7412 4.96682 11.5023 4.96682 11.3544 5.11471L9.5 6.9653L7.64562 5.11092C7.49772 4.96303 7.25882 4.96303 7.11092 5.11092C6.96303 5.25882 6.96303 5.49772 7.11092 5.64562L8.9653 7.5L7.11092 9.35438C6.96303 9.50227 6.96303 9.74118 7.11092 9.88908C7.25882 10.037 7.49772 10.037 7.64562 9.88908L9.5 8.0347L11.3544 9.88908C11.5023 10.037 11.7412 10.037 11.8891 9.88908C12.037 9.74118 12.037 9.50227 11.8891 9.35438L10.0347 7.5L11.8891 5.64562C12.0332 5.50152 12.0332 5.25882 11.8891 5.11471Z"
          fill="#323232"
          stroke="#323232"
          strokeWidth="0.3"
        />
      </Fragment>
    ),
  },
  library_add: {
    width: 16,
    height: 16,
    viewbox: '0 0 16 16',
    body: () => (
      <>
        <path
          d="M2.66668 4.00001H1.33334V13.3333C1.33334 14.0667 1.93334 14.6667 2.66668 14.6667H12V13.3333H2.66668V4.00001ZM13.3333 1.33334H5.33334C4.60001 1.33334 4.00001 1.93334 4.00001 2.66668V10.6667C4.00001 11.4 4.60001 12 5.33334 12H13.3333C14.0667 12 14.6667 11.4 14.6667 10.6667V2.66668C14.6667 1.93334 14.0667 1.33334 13.3333 1.33334ZM13.3333 10.6667H5.33334V2.66668H13.3333V10.6667Z"
          fill="#2F2F32"
        />
        <path
          d="M9.25999 6.6C9.97796 6.6 10.56 6.01797 10.56 5.3C10.56 4.58203 9.97796 4 9.25999 4C8.54202 4 7.95999 4.58203 7.95999 5.3C7.95999 6.01797 8.54202 6.6 9.25999 6.6Z"
          fill="#2F2F32"
        />
        <path
          d="M11.8533 8.90669C11.8533 8.04002 10.1267 7.60669 9.25999 7.60669C8.39332 7.60669 6.66666 8.04002 6.66666 8.90669V9.34002H11.8533V8.90669Z"
          fill="#2F2F32"
        />
      </>
    ),
  },
  exit: {
    viewBox: '0 0 16 16',
    width: 16,
    height: 16,
    body: () => (
      <Fragment>
        <path d="M2.66667 3.33333L7.33333 3.33333C7.7 3.33333 8 3.03333 8 2.66667C8 2.3 7.7 2 7.33333 2L2.66667 2C1.93333 2 1.33333 2.6 1.33333 3.33333L1.33333 12.6667C1.33333 13.4 1.93333 14 2.66667 14L7.33333 14C7.7 14 8 13.7 8 13.3333C8 12.9667 7.7 12.6667 7.33333 12.6667L2.66667 12.6667L2.66667 3.33333Z" />
        <path d="M10.8663 6.06681C10.6063 5.80681 10.6063 5.39348 10.8663 5.13348C11.1263 4.87348 11.5397 4.87348 11.7997 5.13348L14.193 7.53348C14.453 7.79348 14.453 8.21348 14.193 8.47348L11.7997 10.8668C11.5397 11.1268 11.1263 11.1268 10.8663 10.8668C10.6063 10.6068 10.6063 10.1935 10.8663 9.93348L12.133 8.66681H5.99967C5.63301 8.66681 5.33301 8.36681 5.33301 8.00014C5.33301 7.63348 5.63301 7.33348 5.99967 7.33348H12.133L10.8663 6.06681Z" />
      </Fragment>
    ),
  },
};
